// extracted by mini-css-extract-plugin
module.exports = {"wrapperCarouselMenu":"CarouselMenu_wrapperCarouselMenu__Nux7Y","itemMenu":"CarouselMenu_itemMenu__zTURK"};